import React, { ReactNode, useState } from 'react';
// @ts-expect-error type isn't available for use-key-hook.
import useKey from 'use-key-hook';
import Popup from '../Popup';

type Props = {
  linkText: string;
  children: ReactNode;
  className?: string;
};

const PopupLink = ({ linkText, children, ...props }: Props) => {
  const [isPopupOpened, setPopupOpened] = useState(false);

  // Close on ESC.
  useKey(
    () => {
      setPopupOpened(false);
    },
    { detectKeys: [27] },
  );

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setPopupOpened(true);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      setPopupOpened(true);
    }
  };

  return (
    <>
      <a href="#" className="popup-link" onClick={onClick} onKeyDown={onKeyDown}>
        {linkText}
      </a>
      {isPopupOpened && (
        <Popup {...props} isVisible onPopupClose={() => setPopupOpened(false)}>
          <div className="inner">{children}</div>
        </Popup>
      )}
    </>
  );
};

export default PopupLink;
